/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraProductDiscoveryGlobalViewAri } from '@atlassian/ari/jira-product-discovery/global-view';
import parameters from './__generated__/PolarisGlobalViewsSettingsDetailsPageQuery$parameters.ts';
import type { PolarisGlobalViewsSettingsDetailsPageQuery } from './__generated__/PolarisGlobalViewsSettingsDetailsPageQuery.graphql.ts';

type PolarisProductGlobalViewsSettingsDetailsEntryPointComponent = EntryPointComponent<
	{
		globalViewsSettingsDetailsQuery: PolarisGlobalViewsSettingsDetailsPageQuery;
	},
	{},
	{},
	{
		globalViewId: string;
	}
>;

export const polarisProductGlobalViewsSettingsDetailsEntryPoint: EntryPoint<
	PolarisProductGlobalViewsSettingsDetailsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PolarisProductGlobalViewsSettingsDetailsEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-global-views-details", jiraSpaEntry: "async-polaris-ideas" */ './PolarisGlobalViewsSettingsDetailsPage.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const globalViewId = context.match.params.viewId;

		if (!globalViewId) {
			// For TS safety. This won't really happen since the viewId is required in the route.
			throw new Error('Global view ID is required');
		}

		return {
			queries: {
				globalViewsSettingsDetailsQuery: {
					options: {
						// let's restore store-or-network with https://pi-dev-sandbox.atlassian.net/browse/POL-21943
						fetchPolicy: 'network-only' as const,
					},
					parameters,
					variables: {
						id: JiraProductDiscoveryGlobalViewAri.create({
							siteId: tenantContext.cloudId,
							activationId: tenantContext.activationId,
							globalViewId,
						}).toString(),
					},
				},
			},
			extraProps: {
				globalViewId,
			},
		};
	},
});
